module.exports = __webpack_public_path__ + "img/uddannelses-og-forskningsministeriet-logo.ad1fde33.svg";